import EventEmitter from 'eventemitter3';
import { noop } from 'lodash';

class KeyboardEvents extends EventEmitter {
  eventHandlers: { [key: string]: (evt: KeyboardEvent) => void } = {
    keydown: noop,
    keyup: noop,
  };
}

export default KeyboardEvents;
